module.exports = __webpack_public_path__ + "img/spain-colorectal-cancer-male.43ea5251.png";